module.exports = __webpack_public_path__ + "static/media/state_ipv_number.41d9595a.svg";